import { render } from "./DraggableItem.vue?vue&type=template&id=454509ff&scoped=true"
import script from "./DraggableItem.vue?vue&type=script&lang=js"
export * from "./DraggableItem.vue?vue&type=script&lang=js"

import "./DraggableItem.vue?vue&type=style&index=0&id=454509ff&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Taitaen Swegon Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454509ff"]])

export default __exports__